export class AtsTrackingHelper {
    public static publishEvent(eventData: IECommerceEventData): void {
        if (window.shell) {
            const dateNow: string = new Date().toISOString();

            window.shell.publishTo('kraken.categoryviewed', {
                'version': 1,
                'eventDate': dateNow,
                'context': {
                    'senderId': 'ESPP1.ArticleTile.Service'
                },
                'type': ECommerceEvent.CategoryViewed,
                'properties': {
                    'category': eventData.navigationKey
                }
            });
        }
    }

    public static publishSearchResultEvent(eventData: ISearchResultEventData): void {
        if (window.shell) {
            const dateNow: string = new Date().toISOString();

            window.shell.publishTo('kraken.searchresults', {
                'version': 1,
                'eventDate': dateNow,
                'context': {
                    'senderId': 'ESPP1.ArticleTile.Service'
                },
                'type': ECommerceEvent.SearchResults,
                'properties': eventData
            });
        }
    }
}

export enum ECommerceEvent {
    CategoryViewed = 'CategoryViewed',
    SearchResults = 'SearchResults'
}

export interface IECommerceEventData {
    'navigationKey': string;
}

export interface ISearchResultEventData {
    contents: ISearchResultEventItem[];
    value: number;
    currency: string;
    searchTerm: string;
}

export interface ISearchResultEventItem {
    id: string;
    type: string;
    name: string;
    category: string;
    numItems: number;
    value: string;
}